import React from "react";

const Hints = ({ hints }) => {
  return (
    <div className={`d-flex flex-column`}>
      <div className="row">
        {hints.map((hint) => {
          return (
            <div
              className="col-12 mb-1 d-flex align-items-center"
              key={hint.name}
            >
              <img src={hint.src} alt={hint.name} />
              {hint.label ===
              "This can not be a picture of your passport photo." ? (
                <span className="d-block ml-1 text-spacedOut text-bluishGray">
                  This can <strong>not</strong> be a picture of your passport
                  photo.
                </span>
              ) : (
                <span className="d-block ml-1 text-spacedOut text-bluishGray">
                  {hint.label}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Hints;
